import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {Text} from '@/components/ui/text/Text'

export const PlannedAccessesTotalCard = ({title, total}: {title: string; total?: number}) => {
    return (
        <FormCardSection columns={1} padding={3}>
            <DetailsField>
                <Text size="textSm" weight="400" palette="neutral" shade="600">
                    {title}
                </Text>
                <Text size="textSm" weight="500" palette="neutral" shade="600">
                    {total || '-'}
                </Text>
            </DetailsField>
        </FormCardSection>
    )
}
